export const pivotHeatmap = (rows, { xKey, yKey, valueKey, xOrder }) => {
  const dataset = rows.data;
  const lookup = new Map(
    dataset.map(r => [`${r[xKey]}|${r[yKey]}`, r[valueKey]])
  );

  // Build labels
  let xLabels = [...new Set(dataset.map(r => r[xKey]))];
  let yLabels = [...new Set(dataset.map(r => r[yKey]))].sort((a, b) => a - b);

  if (xOrder) {
    xLabels = xOrder;
  } else {
    xLabels = xLabels.sort((a, b) => a - b);
  }

  // Build 2D data matrix using lookup
  const data = yLabels.map(y =>
    xLabels.map(x => lookup.get(`${x}|${y}`) || 0)
  );

  return { xLabels, yLabels, data, xKey, yKey };
};
